export enum QualityAssuranceTablesEnum {
  Findings = 'Findings',
  ClaimProjects = 'ClaimProjects',
  UnderwritingProjects = 'UnderwritingProjects',
}
